import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Image from '../../../../components/ContentfulImage';
import Placeholder from '../../../../components/Placeholder';
import { Background, Wrapper, Title, Description, StartButton, SkipLink,BackgroundImage } from './EmotionalPage.style';
import { saveSublimicStylistDiagnosis, saveSublimicUserSurvey } from '../../../../redux/actions/sublimicDiagnosis';

class EmotionalPage extends React.Component {
  state = { isLoadUserSurvey: false, isLoadStylistDiagnosis: false};

  componentWillMount = () => {
    const { customerProfile } = this.props;
    // if(Object.keys(customerProfile).length > 0) {
    //   this.loadSublimicDiagnosis(customerProfile);
    // }
  }

  componentDidMount(){
    localStorage.removeItem('sublimic-skippedUserSurvey');
  }

  componentWillReceiveProps(nextProps) {
    // if(Object.keys(nextProps.customerProfile).length > 0) {
    //   this.loadSublimicDiagnosis(nextProps.customerProfile);
    // }
  }

  loadSublimicDiagnosis = customerProfile => {
    const { saveSublimicUserSurvey, saveSublimicStylistDiagnosis } = this.props;
    const { isLoadUserSurvey, isLoadStylistDiagnosis } = this.state;
    if(!isLoadUserSurvey && customerProfile.userSurveyResult &&
      customerProfile.userSurveyResult.result &&
      customerProfile.userSurveyResult.result.length > 0) {
        this.setState({isLoadUserSurvey: true});
        saveSublimicUserSurvey(customerProfile.userSurveyResult.result);
    }
    if(!isLoadStylistDiagnosis && customerProfile.stylistDiagnosisResult &&
      customerProfile.stylistDiagnosisResult.result &&
      Object.keys(customerProfile.stylistDiagnosisResult.result).length !== 0 &&
      customerProfile.stylistDiagnosisResult.result.constructor === Object) {
        this.setState({isLoadStylistDiagnosis: true});
      saveSublimicStylistDiagnosis(customerProfile.stylistDiagnosisResult.result);
    }
  };

  next = () => {
    const { history } = this.props;
    history.push('diagnosis/user-survey');
  };

  nextSkip = () => {
    const { history } = this.props;
    // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
    // const path = this.useCamera() ? 'diagnosis/scalp-camera' : 'diagnosis/stylist-diagnosis';
    localStorage.setItem('sublimic-skippedUserSurvey', true);
    // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
    // history.push(path);
    history.push('diagnosis/stylist-diagnosis');
  };

  useCamera = () => {
    const { authSalonSettings } = this.props;
    if (authSalonSettings && authSalonSettings.others && authSalonSettings.others.useCamera) {
      return authSalonSettings.others.useCamera.toLowerCase() === 'true' ? true : false;
    }
    return false;
  };

  render() {
    const { copy, backgroundImage} = this.props;
    return (
      <Background>
        <Wrapper>
          {copy.emotional.title ? <Title dangerouslySetInnerHTML={{ __html: copy.emotional.title }} /> : <Title><Placeholder w={['300px', '550px']} h="40px" /></Title>}
          {copy.emotional.description ? <Description dangerouslySetInnerHTML={{ __html: copy.emotional.description }} /> : <Description><Placeholder w={['300px', '520px']} h={['72px', '68px']} /></Description>}
          {copy.emotional.surveyCtaLabel ? <StartButton onClick={this.next}>{copy.emotional.surveyCtaLabel}</StartButton> : <div className="placeholder_Box"><Placeholder w="300px" h={['50px', '65px']} /></div> }
          <SkipLink onClick={this.nextSkip}>{copy.emotional.skipSurveyCtaLabel || <Placeholder w="160px" h="20px" />}</SkipLink>
        </Wrapper>
        <BackgroundImage>
          {/* {backgroundImage ? <Image src={backgroundImage} options={{ w: '100%', h: '100%', objectFit: 'cover' }} /> : null} */}
          {backgroundImage ? <img src={backgroundImage.file.url} /> : null}
        </BackgroundImage>
      </Background>
    );
  }
}

EmotionalPage.defaultProps = {
  copy: {
    emotional: {
      title: undefined,
      description: undefined,
      surveyCtaLabel: undefined,
      skipSurveyCtaLabel: undefined,
    },
  },
  authSalonSettings: {},
};

EmotionalPage.propTypes = {
  copy: PropTypes.shape(),
  authSalonSettings: PropTypes.shape(),
};

const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  backgroundImage: state.sublimicHome.emotionalBackgroundImage,
  locale: state.locale,
  authSalonSettings: state.authSalonSettings,
  customerProfile: state.customerProfile,
});
const mapDispatch = dispatch => ({
  saveSublimicUserSurvey: data => dispatch(saveSublimicUserSurvey(data)),
  saveSublimicStylistDiagnosis: data => dispatch(saveSublimicStylistDiagnosis(data)),
});

export default connect(mapState, mapDispatch)(EmotionalPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/EmotionalPage/EmotionalPage.js